import TailwindPageWrapper from "./TailwindPageWrapper";

const withTailwindPage = (WrappedComponent) => {
  const WrappedPage = (props) => (
    <TailwindPageWrapper>
      <WrappedComponent {...props} />
    </TailwindPageWrapper>
  );

  WrappedPage.displayName = `WithTailwindPage(${WrappedComponent.displayName || WrappedComponent.name || "Component"})`;

  return WrappedPage;
};

export default withTailwindPage;

